const locale = {
  placeholderCountry: '请选择国家',
  placeholderInput: '请输入{label}',
  notAllowedEmpty: '{label}不能为空',
  incorrectFormat: '{label}格式不正确'
};

export default locale;
